<template>
    <button v-on:click="modalsSetShow('Login')" class="auth-button">
        <div class="button-inner">
            <IconRoblox class="icon" />
            SIGN IN
        </div>
    </button>
</template>

<script>
    import { mapActions } from 'vuex';
    import IconRoblox from '@/components/icons/IconRoblox';

    export default {
        name: 'AuthButton',
        components: {
            IconRoblox
        },
        methods: {
            ...mapActions(['modalsSetShow'])
        }
    };
</script>

<style scoped>
button.auth-button {
    height: 50px;
    filter: drop-shadow(0px 2px 10px rgba(1, 230, 169, 0.15));
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    background: linear-gradient(255deg, #00aeff 0%, #003caa 100%);
    clip-path: polygon(9px 0, calc(100% - 9px) 0, 100% 25%, 100% 75%, calc(100% - 9px) 100%, 9px 100%, 0 75%, 0 25%);
}

button.auth-button:hover {
    transform: translateY(-2px);
    box-shadow: 0px 4px 12px rgba(0, 255, 194, 0.3);
}

button.auth-button .button-inner {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 22px;
    font-size: 16px;
    font-weight: 800;
    color: #ffffff;
}

button.auth-button .icon {
    width: 20px;
    height: 20px;
    fill: currentColor; /* Inherit text color for seamless styling */
    transition: transform 0.3s ease, fill 0.3s ease;
    margin-right: 11px;
}

button.auth-button:hover .icon {
    transform: rotate(15deg); /* Subtle rotation on hover */
    fill: #00aeff; /* Change icon color on hover */
}
</style>
